export default __webpack_public_path__ + "static/media/paypal.13d34f1a.png";